import { fetcher } from '@commenda/utils';

import {
  LinkRegistrationDocumentBody,
  LinkRegistrationDocumentResponse,
  LinkRegistrationDocumentResult,
} from './types';

export type {
  LinkRegistrationDocumentBody,
  LinkRegistrationDocumentResponse,
  LinkRegistrationDocumentResult,
} from './types';

export async function linkRegistrationDocument(
  businessEntityId: number,
  registrationId: string,
  body: LinkRegistrationDocumentBody
): Promise<LinkRegistrationDocumentResult> {
  try {
    const response = await fetcher(
      `business-entities/${businessEntityId}/registrations/${registrationId}/documents`,
      {
        method: 'POST',
        body,
      }
    );

    if (!response.ok) return { success: false, error: response.statusText };

    const data: LinkRegistrationDocumentResponse = await response.json();
    return { success: true, data };
  } catch {
    return { success: false, error: 'Could not link registration document' };
  }
}
